import { createContext } from 'react';
/**
 * Citrus user preference provider
 *
 * @type React.Context
 * @example
 * <CitrusUser.Provider value={{ lang: 'en-US' }}>
 *   <div>Your App Goes Here</div>
 * </CitrusUser.Provider>
 */
export var CitrusUser = createContext({
    lang: 'en-US',
});
